// extracted by mini-css-extract-plugin
export default {"noData":"styles_noData__IQuMl","documentsCollapse":"styles_documentsCollapse__HdJMv","expandIconWrap":"styles_expandIconWrap__5QUyK","headerLeft":"styles_headerLeft__4LjPv"};